import { INotification } from '../_types'
import { request } from './http-client'
import { TParams } from './types'

const notificationService = {
  getAll: (params: TParams) =>
    request.get<{ notifications: INotification[]; count: number }>(
      `/v2/notifications`,
      { params }
    ),
  getById: (id: string, token?: string) =>
    request.get<INotification>(`/v2/notifications/${id}`, {
      headers: { Authorization: token },
    }),
}

export default notificationService
